import get from 'lodash/get';

import { CustomAttributeDefinition } from '../../CAD.types';
import { CAD_STORE_KEY } from '../../constants';
import { STATE_KEY } from './CADList.constants';

interface CADListStore {
	loading: boolean;
	deleteInProgress: boolean;
	data: CustomAttributeDefinition[];
	showDeleteModal: boolean;
}

const getCADList = (store: unknown): CADListStore =>
	get(store, [CAD_STORE_KEY, STATE_KEY], {}) as CADListStore;
export const getCADListLoading = (store: unknown): boolean =>
	get(getCADList(store), 'loading', false);
export const getCADListDeleteInProgress = (store: unknown): boolean =>
	get(getCADList(store), 'deleteInProgress');
export const getCADListData = (store: unknown): CustomAttributeDefinition[] =>
	get(getCADList(store), 'data', []);
export const getCADListShowModal = (store: unknown): boolean =>
	get(getCADList(store), 'showDeleteModal');
